import React, { useEffect, useState } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { formatDate, getFormattedDateTime } from '../../../Util/DateFunctions';
import useGuiTranslations from '../../../Components/MultiLanguage/useGuiTranslations';

export default function OrderHistoryLine(props) {
    const [translateGui] = useGuiTranslations();
    const { order } = props;
    const [displayDetails, setDisplayDetails] = useState(false);

    useEffect(
        () => {

        }, []
    )

    return (
        <React.Fragment>

            <TableRow key={order.orderNumber}>
                <TableCell component="td" scope="row">
                    {order.orderNumber.substring(0, 6)}
                </TableCell>
                <TableCell component="td" scope="row">

                    <span className="inline-block ilk-harf-buyuk">
                        {
                            order.orderType == "SelfOrder" ?
                                translateGui(21)
                                : null
                        }
                        {
                            order.orderType == "Collect" ?
                                translateGui(22)
                                : null
                        }
                        {
                            order.orderType == "Deliver" ?
                                translateGui(23)
                                : null
                        }
                    </span>
                </TableCell>
                <TableCell align="left">{getFormattedDateTime(order.orderDate)}</TableCell>
                <TableCell align="right">{order.orderAmount}</TableCell>
                <TableCell align="right">
                    <i style={{ cursor: 'pointer' }} className="material-icons" onClick={() => setDisplayDetails(!displayDetails)}>
                        {displayDetails ? 'expand_less' : 'expand_more'}
                    </i>
                </TableCell>

            </TableRow>

            {
                displayDetails ?
                    <TableRow key={'_' + order.orderNumber}>
                        <TableCell component="td" scope="row">
                            {
                                order.orderDetail.map(
                                    orderItem =>

                                        <div>
                                            {orderItem.itemQuantity}x {orderItem.foodOrDrink} {orderItem.itemAmount}
                                        </div>

                                )
                            }
                        </TableCell>
                    </TableRow>
                    : null
            }
        </React.Fragment>
    )
}



